export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setEmail('');
      return;
    }

    if (!email || !email.includes('@')) {
      setStatus('error');
      setErrorMsg('请输入有效的邮箱地址');
      return;
    }

    setStatus('loading');

    try {
      const submitData = new FormData();
      submitData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d9rff5ee3oq4jqumu0lg', {
        method: 'POST',
        body: new URLSearchParams({ email }).toString(),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        if (serverMsg.includes('spam')) {
          setStatus('success');
          setEmail('');
        } else {
          setStatus('error');
          setErrorMsg(serverMsg || '订阅失败，请稍后重试');
        }
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请稍后重试');
    }
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-2xl mx-auto text-center">
        <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-2xl bg-primary-50">
          <i className="ri-mail-send-line text-2xl text-primary-500"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
          订阅开元体育资讯
        </h2>
        <p className="text-foreground-600 text-sm mb-8">
          第一时间获取最新赛事分析、优惠活动和平台动态
        </p>

        {status === 'success' ? (
          <div className="bg-accent-50 border border-accent-200 rounded-xl p-6">
            <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
              <i className="ri-check-line text-xl text-accent-600"></i>
            </div>
            <p className="text-accent-800 font-semibold">订阅成功！</p>
            <p className="text-accent-600 text-sm mt-1">感谢您的订阅，我们会将最新资讯发送到您的邮箱</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} data-readdy-form="true" className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto">
            <div className="honeypot-field">
              <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setStatus('idle'); }}
              placeholder="请输入您的邮箱地址"
              className="flex-1 px-5 py-3 rounded-full border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
              required
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full text-sm transition-all duration-200 whitespace-nowrap disabled:opacity-60"
            >
              {status === 'loading' ? '提交中...' : '立即订阅'}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="text-primary-600 text-sm mt-3">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}